import { Layout } from "@/modules/DashboardTemplate/models/Layout";
import { cloneDeep } from "lodash";
import { normalizeLayout } from "./normalizeLayout";

function isOverlapping(a: Layout, b: Layout, gap = 0): boolean {
  return (
    a.x < b.x + b.width + gap &&
    a.x + a.width > b.x - gap &&
    a.y < b.y + b.height + gap &&
    a.y + a.height > b.y - gap
  );
}

export function resolveOverlaps<T extends { layout?: Layout }>(
  internalValue: T[],
  separation: number
) {
  const normalized = internalValue.map(item => ({
    ...item,
    layout: normalizeLayout(cloneDeep(item.layout))
  }));

  const resolved = normalized.map(item => ({
    ...item,
    layout: cloneDeep(item.layout)
  }));
  const sorted = [...resolved].sort((a, b) => a.layout.y - b.layout.y);

  for (let i = 0; i < sorted.length; i++) {
    const a = sorted[i].layout;
    for (let j = i + 1; j < sorted.length; j++) {
      const b = sorted[j].layout;
      if (isOverlapping(a, b, separation)) {
        const newY = a.y + a.height + separation;
        const targetb = resolved.find(r => r.layout === b);
        const targeta = resolved.find(r => r.layout === a);
        if (targeta) {
          targeta.layout = {
            ...targeta.layout,
            x: 0
          };
        }

        if (targetb) {
          targetb.layout = {
            ...targetb.layout,
            y: newY,
            x: 0
          };
        }
      }
    }
  }

  return resolved;
}
